const HEADER_MOD = {
  "Does your commerce solution offer a comprehensive portfolio of easy-to-use tools for all business users, regardless of technical knowledge?":
    {
      header: "BUSINESS USER TOOLING",
      negCopy:
        "Empower your business users to work more efficiently and effectively with tooling designed for the non-technical user.",
      negLink: "",
      negLinkTxt: "",
    },
  "How effective is your SEO strategy?":
    {
      header: "SEO",
      negCopy:
        "Increase site traffic through concentrated keywords and metadata to improve search ranking.",
      negLink: "",
      negLinkTxt: "",
    },
  "How effective is your search experience in guiding customers to their desired purchases?": {
    header: "SEARCH AND NAVIGATION",
    negCopy:
      "Efficiently manage and scale the search experience with industry-leading search and guided navigation capabilities.",
    negLink: "",
    negLinkTxt: "",
  },
  "How effective is your product recommendation strategy?":
    {
      header: "INTELLIGENT RECOMMENDATIONS",
      negCopy:
        "Increase conversions and average order value with intelligent cross-sell and upsell recommendations.",
      negLink: "",
      negLinkTxt: "",
    },
  "Is your customer data connected across CX, finance, and operations applications to better understand and serve your customers’ needs?":
    {
      header: "UNIFIED CUSTOMER DATA",
      negCopy:
        "Create a unified view of your customer by connecting and synchronizing data across your core business applications.",
      negLink: "",
      negLinkTxt: "",
    },
  "How much variability in pricing and catalogs can you support on your digital channels?":
    {
      header: "CUSTOM CATALOGS AND PRICING",
      negCopy:
        "Deliver custom catalogs, negotiated pricing, and payment terms specific to each business account.",
      negLink: "",
      negLinkTxt: "",
    },
  "How effectively are you able to design and manage promotions strategies?":
    {
      header: "PROMOTIONS",
      negCopy:
        "Used effectively, promotions and discounting strategies can help you attract new customers to grow your business.",
      negLink: "",
      negLinkTxt: "",
    },
  "Does your commerce solution foster customer loyalty with offers and promotions based on frequent purchase history?":
    {
      header: "LOYALTY FRAMEWORK",
      negCopy:
        "Boost engagement and customer lifetime value with loyalty programs.",
      negLink: "",
      negLinkTxt: "",
    },
  "How capable is your commerce solution in adapting to current and future business needs?": {
    header: "SCALABILITY & ADAPTABILITY",
    negCopy:
      "Address the ecommerce challenges of today and the opportunities of tomorrow with an open and scalable platform and API-first approach.",
    negLink: "",
    negLinkTxt: "",
  },
  "Is data connected across your organization in a way that allows for actionable, real-time insights to improve commerce outcomes?": {
    header: "DATA INSIGHTS",
    negCopy:
      "Turn information into insights with real-time and historic customer and site data.",
    negLink: "",
    negLinkTxt: "",
  },
  "Is your commerce solution flexible enough to deploy using full stack capabilities, go fully headless, or take a hybrid approach?":
    {
      header: "FLEXIBLE DEPLOYMENT ARCHITECTURE",
      negCopy:
        "Achieve your commerce goals and meet any business need with a flexible commerce solution.",
      negLink: "",
      negLinkTxt: "",
    },
  "Are you able to empower developers to innovate using flexible frameworks?":
    {
      header: "MODERN COMMERCE FRAMEWORKS",
      negCopy:
        "Embolden your internal stakeholders by providing access to the latest tools and frameworks.",
      negLink: "",
      negLinkTxt: "",
    },
  "Is your commerce solution supported by cost-effective architecture?": {
    header: "IT COMPLEXITY AND COSTS",
    negCopy:
      "Drive innovation and digital transformation by increasing maximizing agility, lowering costs, and reducing IT complexity.",
    negLink: "",
    negLinkTxt: "",
  },
  "How easily can your commerce solution integrate with other applications to achieve all of your desired capabilities across the customer lifecycle?":
    {
      header: "EASE OF INTEGRATION",
      negCopy:
        "Customize your commerce experience to meet the needs of your business and your customers to grow your digital business.",
      negLink: "",
      negLinkTxt: "",
    },
  "How effectively can campaign managers seamlessly connect campaigns and customer journeys across marketing and commerce experiences?":
    {
      header: "OMNICHANNEL CAMPAIGN MANAGEMENT",
      negCopy:
        "Progress customers through the funnel even for self-service buying journeys with seamless end-to-end campaigns.",
      negLink: "",
      negLinkTxt: "",
    },
  "Are your commerce teams able to access and utilize approved brand, campaign, and other marketing content and assets efficiently?": {
    header: "CONTENT MANAGEMENT",
    negCopy:
      "Maximize marketing efficiency with a shared content repository that can be easily accessed and utilized by your commerce business users.",
    negLink: "",
    negLinkTxt: "",
  },
  "How personalized is your customer’s buying experience?":
    {
      header: "CUSTOMER INTELLIGENCE",
      negCopy:
        "Engage customers with tailored experiences that reflect their previous and current interactions with you across channels.",
      negLink: "",
      negLinkTxt: "",
    },
  "Does your ecommerce platform use AI and/or machine learning to offer recommended products and services based on customers’ buying habits?":
    {
      header: "AI_POWERED RECOMMENDATIONS",
      negCopy:
        "Enhance the relevance of your product and service offerings on your site with AI-powered recommendations based on buyers’ past digital engagements.",
      negLink: "",
      negLinkTxt: "",
    },
  "Does your commerce solution support loyalty programs for frequent customer engagement?":
    {
      header: "LOYALTY FRAMEWORK",
      negCopy:
        "Boost engagement and customer lifetime value with a built-in loyalty framework.",
      negLink: "",
      negLinkTxt: "",
    },
  "Can customers confidently explore your offerings, complete transitions, and manage their account information without speaking to a rep?":
    {
      header: "BUYER CONFIDENCE",
      negCopy:
        "Give buyers the freedom and flexibility to own their purchasing experience by empowering them with the knowledge and information needed to successfully self-serve.",
      negLink: "",
      negLinkTxt: "",
    },
  "Are you able to capture buying signals across channels to engage customers with the right offer in the moments that matter?":
    {
      header: "CUSTOMER INTELLIGENCE",
      negCopy:
        "Combine customer data and applied intelligence across channels to help sellers interpret buyer signals and deliver the right offer at the right time.",
      negLink: "",
      negLinkTxt: "",
    },
  "Does your commerce experience guide self-service buyers through complex purchases and product configurations?":
    {
      header: "COMPLEX PRODUCTS AND SERVICES",
      negCopy:
        "Deliver complete self-service experiences straight from the storefront and put the power in the customer’s hands.",
      negLink: "",
      negLinkTxt: "",
    },
  "Can you support dynamic business models on self-service channels, providing customers tools to manage their own orders and accounts?":
    {
      header: "RECURRING REVENUE MODELS",
      negCopy:
        "Enabling dynamic, recurring revenue models across your business and self-service channels can help grow your business.",
      negLink: "",
      negLinkTxt: "",
    },
};
export default HEADER_MOD;
